module.exports = __webpack_public_path__ + "img/16800.093eb467.jpg";